import React from "react";
import "../styles/EditRole.css";
import BusinessHubHeader from "../components/BusinessHubHeader";
import BackArrow from "../icons/BusinessHub/BackArrow";
import RoleIcon from "../icons/BusinessHub/RoleIcon";
import DescriptionIcon from "../icons/BusinessHub/DescriptionIcon";
import { useState, useEffect, useRef } from "react";
import SearchIcon from "../icons/BusinessHub/SearchIcon";
import { useNavigate } from "react-router-dom";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import userController from "../controllers/userController";
import { useLocation } from "react-router-dom";
import { userService } from "../services/userService";

function EditUserRole() {
  const { state } = useLocation();
  const { roleID, roleName, roleDescription, permissionIDs = [] } = state;
  const jwt = userService.getUser();
  const companyID = userService.getCompID();
  const navigate = useNavigate();
  const [RoleAdd, setRoleAdded] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [permID, setPermID] = useState([]);
  const [roledesc, setroledesc] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const allChecked =
    data.length > 0 &&
    data.every((item) => selected.includes(item.permissionID));
  const toggleAll = (e) => {
    if (e.target.checked) {
      const allIDs = data.map((item) => item.permissionID);
      setSelected(allIDs);
      setPermID(allIDs);
    } else {
      setSelected([]);
      setPermID([]);
    }
  };
  const toggleOne = (permissionID) => {
    setSelected((prev) => {
      const updated = prev.includes(permissionID)
        ? prev.filter((x) => x !== permissionID)
        : [...prev, permissionID];

      setPermID(updated);
      return updated;
    });
  };
  useEffect(() => {
    try {
      const getData = async () => {
        const perm = await userController.GetAllPermission({
          jwt: jwt,
          application: 1,
        });
        setData(perm.data);
      };
      getData();
    } catch (error) {
      console.log("error getting permisions");
    }
  }, []);

  const handleSaveChange = async () => {
    const addRole = {
      companyId: companyID,
      permissionIDs: permID,
      roleDescription: roledesc,
      roleId: roleID,
      roleName: roleName,
    };
    try {
      const addRoleReq = await userController.AddRole({
        addRole: addRole,
        jwt: jwt,
      });
      if (addRoleReq.data) {
        navigate("/user-management", {
          state: { active: "C" },
        });
      }
    } catch (error) {
      console.log(error);
      console.log("err");
    }
  };
  useEffect(() => {
    if (Array.isArray(permissionIDs) && permissionIDs.length > 0) {
      setSelected(permissionIDs);
      setPermID(permissionIDs);
    }
  }, [permissionIDs]);

  const filteredData = data.filter((item) =>
    item.permissionName.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  return (
    <div className="edit-role-screen-container">
      <div className="edit-role-page-header">
        <BusinessHubHeader />
      </div>
      <div className="edit-role-page-content">
        {RoleAdd && (
          <div className="edit-role-popup-container">
            <div
              className="edit-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-role-popup-content">
                <div className="edit-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-role-successfully-added-text">
                  Role Updated Successfully
                </div>
                <div
                  className="edit-role-successfully-added-action-button"
                  onClick={() => handleSaveChange()}
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="edit-role-container">
          <div className="edit-role-container-header">
            <div className="role-header-nav">
              <div
                className="role-header-nav-icon"
                onClick={() =>
                  navigate("/user-management", {
                    state: { active: "C" },
                  })
                }
              >
                <BackArrow />
              </div>
              <div className="role-header-nav-text">
                Back to User Management
              </div>
            </div>
            <div className="role-header-title">Edit Role Details</div>
            <div className="role-header-title-desc">
              Update role information and permissions
            </div>
          </div>
          <div className="edit-role-container-body">
            <div className="edit-role-body-cell">
              <div className="role-cell-header">
                <div className="add-role-header-role-selection">
                  <div className="add-role-select-role">
                    Role <div className="required">*</div>
                  </div>
                  <div className="add-role-select-input-container">
                    <div className="add-roll-selection-icon">
                      <RoleIcon />
                    </div>
                    <div className="add-role-selection-input">{roleName}</div>
                  </div>
                </div>
                <div className="add-role-header-description">
                  <div className="add-role-desc-container-title">
                    <div className="add-role-desc-icon">
                      <DescriptionIcon />
                    </div>
                    <div className="add-role-desc-text">
                      Description<div className="required">*</div>
                    </div>
                  </div>
                  <div className="add-role-desc-cell">
                    <textarea
                      className="add-role-desc-text-input"
                      placeholder={roleDescription}
                      value={roledesc}
                      onChange={(e) => setroledesc(e.target.value)}
                      maxLength={140}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="role-cell-body">
                <div className="role-cell-body-searchbar">
                  <div className="role-cell-search-cell">
                    <div className="role-cell-search-inner-container">
                      <input
                        className="role-cell-searchbar-input"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      ></input>
                      <div className="role-cell-search-icon">
                        <SearchIcon />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="role-and-per-table">
                  <div className="add-roles-table-header-row">
                    <div className="cell-content-roll-desc">
                      <input
                        className="permission-checkbox"
                        type="checkbox"
                        checked={allChecked}
                        onChange={toggleAll}
                      ></input>
                    </div>
                    <div className="edit-role-cell-content">Permission</div>
                  </div>
                  {filteredData.map((item, index) => (
                    <div className="edit-role-table-row" key={index}>
                      <div className="edit-role-checkbox-cell">
                        <input
                          type="checkbox"
                          checked={selected.includes(item.permissionID)}
                          onChange={() => toggleOne(item.permissionID)}
                        />
                      </div>
                      <div className="cell-content-edit-roll-desc">
                        {item.permissionName}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="edit-role-cell-footer">
                <div className="edit-role-action-buttons">
                  <div
                    className="edit-user-save-changes-button"
                    onClick={() => setRoleAdded(true)}
                  >
                    Save Changes
                  </div>
                  <div
                    className="edit-user-cancel-changes-button"
                    onClick={() =>
                      navigate("/user-management", {
                        state: { active: "C" },
                      })
                    }
                  >
                    Cancel
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditUserRole;
